module.exports = __webpack_public_path__ + "static/media/风BU1623彩钢-开门方向.a76e32ba.pdf";